<template>
    <div>
        <v-card>
            <v-toolbar
                flat
                color="primary"
                dark
                dense
            >
                <v-icon left>mdi-security</v-icon>
                  Security Groups
                <v-spacer />
                <v-btn
                    round
                    color="success"
                    :to="{name: 'OrgSelectedGroups', params: {id: 'new'}}"
                >
                    <v-icon left>add</v-icon>
                    New Group
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout
                    row
                    wrap
                >
                    <v-flex
                        sm3
                        style="display:flex;flex-direction: column;"
                    >
                        <v-text-field
                          v-model="search"
                          box
                          hide-details
                          :loading="loading"
                          label="Search Groups"
                          clearable
                          style="flex-grow: 0;"
                        />
                        <v-list
                            three-line
                            style="background: rgba(0,0,0,.03);border-radius: 5px;flex-grow: 1;"
                        >
                            <v-list-tile
                                v-for="group in groups"
                                :key="group.id"
                                :to="{name: 'OrgSelectedGroups', params: {id: group.id}}"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="group.name" />
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn
                                :disabled="!canPrev"
                                icon
                                @click="goPage(-1)"
                            >
                                <
                            </v-btn>
                            &nbsp;
                            {{page * 10 - 9}}
                            -
                            {{page * 10 > total ? total : page * 10}}
                             of 
                            {{total}}
                            &nbsp;
                            <v-btn
                                :disabled="!canNext"
                                icon
                                @click="goPage(1)"
                            >
                                >
                            </v-btn>
                            <v-spacer />
                        </v-card-actions>
                    </v-flex>
                    <v-flex
                        sm9
                    >
                        <v-card
                            v-if="focusGroup || loadingGroup"  
                            style="margin: 0 10px 0 10px;"
                        >
                            <v-toolbar
                                dense
                                flat
                            >
                                Edit Security Group
                                <v-spacer />
                                <v-btn
                                    small
                                    @click="$router.replace({name: 'OrgGroups'})"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    :disabled="!changed || saving"
                                    color="primary"
                                    small
                                    @click="saveGroup()"
                                >
                                    Save Changes
                                </v-btn>
                            </v-toolbar>
  
                            <v-card-text
                                v-show="loadingGroup"
                            >
                                <div
                                    style="padding: 25px;margin:auto"
                                >
                                    <v-progress-linear
                                        indeterminate
                                        query
                                    />
                                </div>
                            </v-card-text>
                            <v-card-text
                                v-if="!loadingGroup"
                            >
                                <v-text-field
                                  v-model="focusGroup.name"
                                  label="Name"
                                />
                                <v-text-field
                                  v-model="focusGroup.description"
                                  label="Description"
                                />
                                <v-switch
                                  v-model="focusGroup.restrict_templates"
                                  label="Restrict visible templates to these case types"
                                />
                                <v-tabs>
                                    <v-tab href="#casetypes">
                                        Case Types
                                    </v-tab>

                                    <v-tab href="#users">
                                        Users
                                    </v-tab>

                                    <v-tab-item
                                        value="casetypes"
                                    >
                                        <v-card flat>
                                            <v-autocomplete
                                                v-model="addCaseType"
                                                :items="casetypes"
                                                :search-input.sync="casetypeSearch"
                                                label="Add Case Type"
                                                item-text="name"
                                                item-value="id"
                                                :return-object="true"
                                                flat
                                                @input="casetypeSearch = ''"
                                            />
                                            <CaseTypePreview
                                                v-for="(ct, index) in focusGroup.casetypes"
                                                :key="ct.id"
                                                :case_type="ct"
                                                :clearable="true"
                                                @clear="focusGroup.casetypes.splice(index, 1)"
                                            />
                                        </v-card>
                                    </v-tab-item>

                                    <v-tab-item
                                        value="users"
                                    >
                                        <v-card flat>
                                            <v-card-text>
                                                <b>
                                                    The following users are assigned to this group:
                                                </b>
                                                <br />
                                                
                                                <v-data-table
                                                    :items="focusGroup.users"
                                                    disable-initial-sort
                                                    hide-headers
                                                >
                                                    <template slot="no-data">
                                                    <tr>
                                                        <td colspan="5">
                                                        <div style="text-align:center;padding:25px;">
                                                            <h3>No Users assigned to this Group</h3>
                                                        </div>
                                                        </td>
                                                    </tr>
                                                    </template>
                                                    <template
                                                        slot="items"
                                                        slot-scope="props"
                                                    >
                                                        <tr :class="{ 'disabled-user': !props.item.is_active }">
                                                            <td>
                                                                <b>{{ props.item.last_name }}</b>
                                                            </td>
                                                            <td>
                                                                {{ props.item.first_name }}
                                                            </td>
                                                            <td>
                                                                {{ props.item.email }}
                                                            </td>
                                                            <td>
                                                                {{ props.item.username }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs>
                            </v-card-text>
                        </v-card>
                      <div
                        v-else
                        style="display:flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;min-height: 600px;width: 100%;margin:auto;"
                      >
                        <div
                          style="text-align:center;font-size: 20px;font-weight: 300;"
                        >
                          <b>Select a Group to edit or create a new Group.</b><br />
                          <small>Set a User's Security Group in the Users tab</small>
                        </div>
                        <div
                          style="display: flex;padding: 10px;background: #ECEFF1;border-radius: 10px;border: 1px solid #78909C;margin-top: 25px;opacity:0.7;max-width:500px;margin: 20px;"
                        >
                          <v-icon
                            left
                            size="32"
                            style="align-self: flex-start;"
                          >
                            mdi-information
                          </v-icon>
                          <div>
                            <div
                              style="font-size: 16px;font-weight: 700;"
                            >
                              About Security Groups
                            </div>
                            <div
                              style="font-size: 12px;"
                            >
                              Security Groups limit the Case Types that a User can view.<br /><br />
                              <b>Important: </b>When a User is added to a Security Group, they will be unable to create new Contacts or Cases.
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>
  </template>
    
  
  <script>
  import api from '@/api'
  import GlobalConstants from '@/globals'
  import { mapActions } from 'vuex'
  import CaseTypePreview from '@/components/admin/cases/CaseTypePreview'
  
  export default {
      components: {
        CaseTypePreview
      },
      data () {
          return {
              groups: null,
              casetypes: [],
              focusGroup: null,
              changed: false,
              loading: false,
              loadingGroup: false,
              saving: false,
              search: null,
              page: 1,
              canNext: false,
              canPrev: false,
              total: 0,
              searching: false,
              addCaseType: null,
              casetypeSearch: '',
          }
      },
      created () {
          if (this.$route.params.id) {
              this.getGroup(this.$route.params.id)
          }
          this.getGroups()
          this.documentTitle('Security Groups')
      },
      methods: {
          getCaseTypes (search = null) {
              this.searching = true
              api.cases.casetype.list({
                search: search, 
                pageNum: 1,
                count: 10
              })
                  .then((data) => {
                      this.casetypes = data['results']
                      this.searching = false
                  })
          },
          goPage (int) {
              if (int < 0 && this.canPrev || int > 0 && this.canNext) {
                  this.page = this.page + int
                  this.getGroups(this.search)
              }
          },
          getGroups (search = null) {
              this.loading = true
              api.users.groups.list({
                search: search, 
                pageNum: this.page
              })
                  .then((data) => {
                      this.total = data['count']
                      this.canNext = data['next_page'] !== null
                      this.canPrev = data['previous_page'] !== null
                      this.groups = data['results']
                      this.loading = false
                  })
          },
          getGroup (id) {
              this.loadingGroup = true
              api.users.groups.get(id)
                  .then((data) => {
                      this.focusGroup = data
                      this.changed = false
                  })
          },
          saveGroup () { 
            this.changed = false
            api.users.groups.save(this.focusGroup)
            .then((data) => {
              if ('id' in this.focusGroup) {
                this.focusGroup = data
              } else {
                this.groups.push(data)
                this.$router.replace({name: 'OrgSelectedGroups', params: {id: data.id}})
              }
            })
            .finally(() => {
              this.changed = false
              this.getGroups(this.search)
              this.$forceUpdate()
            })
          }
      },
      async beforeRouteUpdate(to, from, next) {
          if (this.changed) {
              const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
              if (!answer)
                  return false
          }
          next()
      },
      beforeRouteLeave (to, from, next) {
          if (this.changed) {
              const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
              if (!answer)
                  return false
          }
          next()
      },
      watch: {   
          $route (to, from) {
              if (to.params.id == "new") {
                this.loadingGroup = true
                this.focusGroup = {
                  name: 'A New Role',
                  casetypes: []
                }
                this.changed = false
                this.loadingGroup = false
              }
              else if (to.params.id) {
                  this.getGroup(to.params.id)
              } 
              else {
                  this.focusGroup = null
              }
          },
          casetypeSearch () {
            if (this.casetypeSearch && this.casetypeSearch !== "") {
                this.getCaseTypes(this.casetypeSearch)
            }
          },
          search () {
              this.page = 1
              this.getGroups(this.search)
          },
          addCaseType () {
            if (this.addCaseType) {
                if (this.focusGroup.casetypes.filter(obj => {
                    return obj['id'] == this.addCaseType['id']
                }).length == 0) {
                    this.focusGroup.casetypes.push(this.addCaseType)
                }
                this.addCaseType = null
                this.casetypeSearch = ''
            }
          },
          focusGroup: {
              handler(newValue, oldValue) {
                  if (this.loadingGroup || !this.$route.params.id) {
                      this.changed = false
                      this.loadingGroup = false
                  }
                  else
                      this.changed = true
              },
              deep: true,
              flush: 'post'
          }
      }
  }
  </script>
    
    <style>    
    .search-bar {
      margin-top: 1em;
    }
    
    table {
      margin-top: 1em;
    }
    </style>
    